/**
 * FAQ accordion: single-open behaviour. Clicking an open item closes it;
 * clicking a closed item opens it and closes any other.
 */
(function ($) {
    'use strict';

    $(function () {
        $('.mnhq-faq__list').on('click', '.mnhq-faq__summary', function () {
            var $trigger = $(this);
            var $item    = $trigger.closest('.mnhq-faq__item');
            var willOpen = !$item.hasClass('is-open');

            // Close all siblings
            $item.siblings('.mnhq-faq__item').removeClass('is-open')
                .find('.mnhq-faq__summary').attr('aria-expanded', 'false');

            $item.toggleClass('is-open', willOpen);
            $trigger.attr('aria-expanded', String(willOpen));
        });
    });
})(jQuery);
